module.exports = __webpack_public_path__ + "img/image12.d8754189.svg";